// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3F8ot","savePackageButton":"ClientWallet_savePackageButton__29vLj"};